export const optionalRightsConfigTenant3 = {
  headings: [
    {
      headingLabel: "#",
      inputType: "label",
      icon: "",
      border: true,
      width: "3%",
    },
    {
      headingLabel: "QTY",
      inputType: "number",
      border: true,
      width: "8%",
    },
    {
      headingLabel: "UNIT",
      inputType: "number",
      border: true,
      width: "8%",
    },
    {
      headingLabel: "",
      inputType: "select",
      border: true,
      width: "6%",
      selectOptions: [],
    },
    {
      headingLabel: "DESCRIPTION",
      inputType: "richtexteditor",
      border: true,
      width: "45%",
    },
    {
      headingLabel: "UNIT PRICE",
      inputType: "number",
      border: true,
      width: "9%",
    },
    {
      headingLabel: "",
      inputType: "label",
      border: true,
      width: "0%",
    },
    {
      headingLabel: "AMOUNT",
      inputType: "label",
      border: true,
      width: "10%",
    }
  ],
  dataNodes: [
    "item_no",
    "quantity",
    "unit_cost",
    "unit_id",
    "description",
    "unit_cost",
    "subtotal_value",
    "subtotal",
  ],
  primaryKey: ["po_line_id"],
  tenantName:["ContentAcquisition"],
  nodeFields: [
    {
      column: "info",
    },
  ],
  inlineEdits: [
    {
      dataNode: "item_no",
      width: "2%"
    },
    {
      dataNode: "quantity",
      width: "6%",
      validateMethod: "validateNumberFloatOnly",
      placeholder: "Qty",
    },
    {
      dataNode: "unit_cost",
      width: "8%",
      validateMethod: "validateNumberFloatOnly",
      placeholder: "Unit",
    },
    {
      dataNode: "unit_id",
      width: "6%",
    },
    {
      dataNode: "description",
      width: "46%",
      placeholder: "Description",
    },
    {
      dataNode: "unit_cost",
      width: "6%",
      placeholder: "Unit Price",
      validateMethod: "validateNumberFloatOnly",
    },
    {
      dataNode: "subtotal_value",
      width: "0%",
    },
    {
      dataNode: "subtotal",
      width: "8%",
    },
  ],
  showActionsItemBottom:[
    {
    dataNode: "po_line_id",
    width: "6%",
  },
  {
    dataNode: "quantity",
    width: "10%",
  },
  {
    dataNode: "unit_cost",
    width: "20%",
  },
  {
    dataNode: "unit_id",
    width: "15%",
  },
  {
    dataNode: "description",
    width: "50%",
  },  
  {
    dataNode: "unit_cost",
    width: "20%",
  },
  {
    dataNode: "rush",
    width: "40%",
    inputType: "text",
    fieldWidth:"30%"
  }
],
  actions: ["copy", "file", "info-circle", "pen", "trash-alt"], 
  isClearFields: true,
};

export const NewPOHeader = {
  po_id: null,
  po_number: null,
  po_prefix: null,
  vendor_id: null,
  vendor_location_id: null,
  notes: null,
  show_season_id: null,
  is_void: 0,
  prod_company_id: null,
  episode_id: null,
};

export const NewPOLine = [
  {
    po_line_id: null,
    po_id: null,
    episode_id: null,
    //gl_number: null,
    // setunit_id: null,
    // set_unit: null,
    // chartofaccount_id: null,
    acc_detail: null,
    description: null,
    quantity: null,
    unit_cost: null,
    subtotal: null,
    total_cost: null,
    currency_code: null,
    created_by: null,
    created_at: null,
    updated_at: null,
    updated_by: null,
    notes: null,
    change_log: [],
  },
];

